/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, PageGridContainer, typography2 } from '@coursera/cds-core';

import { usePageHeaderHeight } from 'bundles/composable-page-header/contexts/PageHeaderHeightContext';
import GetS12nCertificateBanner from 'bundles/enroll/components/common/GetS12nCertificateBanner';
import type { GetS12nCertificateBannerProps } from 'bundles/page/types/Program';

const BANNER_HEIGHT = 80;

type Props = {
  getS12nCertificateBannerProps?: GetS12nCertificateBannerProps;
};

const styles = {
  banner: css`
    .rc-GetS12nCertificateBanner {
      p {
        font: ${typography2.bodyPrimary.font};
      }

      button,
      a {
        font: ${typography2.actionPrimary.font};
      }
    }
  `,
};

const LegacyGetS12nCertBannerWrapper = ({ getS12nCertificateBannerProps }: Props) => {
  const pageHeaderHeightContext = usePageHeaderHeight();
  const { s12nSlug } = getS12nCertificateBannerProps || {};

  const addHeight = (legacyArg: string) => {
    if (!pageHeaderHeightContext) {
      return;
    }
    pageHeaderHeightContext.setHeight(pageHeaderHeightContext.height + BANNER_HEIGHT);
  };

  const removeHeight = (legacyArg: string) => {
    if (!pageHeaderHeightContext) {
      return;
    }
    pageHeaderHeightContext.setHeight(pageHeaderHeightContext.height - BANNER_HEIGHT);
  };

  return (
    <PageGridContainer>
      <Grid item xs={12} css={styles.banner}>
        <GetS12nCertificateBanner
          addParentHeightClass={addHeight}
          removeParentHeightClass={removeHeight}
          s12nSlug={s12nSlug}
        />
      </Grid>
    </PageGridContainer>
  );
};

export default LegacyGetS12nCertBannerWrapper;
